module.exports = __webpack_public_path__ + "img/parter-avatar0.82755d1c.png";